import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { newMovies } from '@/mocks/movies';

export default function NewMovies() {
  return (
    <section className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                最新上线
              </h2>
              <p className="mt-1 text-sm text-foreground-500">
                刚上线的高清资源，抢先体验
              </p>
            </div>
            <Link
              to="/category/kehuan"
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看更多
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
            {newMovies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}